"use strict";
/*
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPathIterator = void 0;
// eslint-disable-next-line @typescript-eslint/no-namespace, no-redeclare
var IPathIterator;
(function (IPathIterator) {
    IPathIterator.SEG_CLOSE = 4;
    IPathIterator.SEG_CUBICTO = 3;
    IPathIterator.SEG_LINETO = 1;
    IPathIterator.SEG_MOVETO = 0;
    IPathIterator.SEG_QUADTO = 2;
    IPathIterator.WIND_EVEN_ODD = 0;
    IPathIterator.WIND_NON_ZERO = 1;
})(IPathIterator || (exports.IPathIterator = IPathIterator = {}));
//# sourceMappingURL=IPathIterator.js.map